const historyLogUserAction = {
	create: 1,
	update: 2,
	delete: 3,
};

const historyLogSource = {
	fulfillmentOrder: 1,
	product: 2,
	marketplaceOrder: 3,
	receiving: 4,
};

const historyLogListFields = ['UPC', 'Product Virtual SKU']; // matches history log constants on the backend

// Change values for these fields are stored in UTC; render as browser-local date+time.
const historyLogUtcDateTimeFields = ['Order date', 'Payment date', 'Deliver by date', 'Assigned Timestamp'];

export { historyLogUserAction, historyLogSource, historyLogListFields, historyLogUtcDateTimeFields };
